import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "What's the free trial for local business data enrichment?",
  answer: 'Every new account gets free credits to test our local business data enrichment before committing to a paid plan. Upload records, enrich local business contacts, and export complete profiles — all at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-600 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'What data does local business contact enrichment include?',
  answer: 'Our local business data enrichment adds 50+ fields to your basic records. This includes verified owner emails, direct phone numbers, job titles, tech stacks, social profiles, revenue estimates, and employee counts.'
}, {
  question: 'How accurate is the local business data enrichment?',
  answer: 'Our local business data enrichment engine cross-references multiple proprietary sources and verifies all contact data in real-time. We cover 200M+ local businesses and update records weekly to ensure accuracy.'
}, {
  question: 'Can I enrich local business contacts in bulk?',
  answer: 'Yes. You can upload CSV files with thousands of records, and our platform will process the local business contact enrichment in bulk. You only pay for the records we successfully enrich with verified data.'
}, {
  question: 'Does business profile enrichment work with my CRM?',
  answer: 'Absolutely. You can sync your enriched local business contacts directly to Salesforce or HubSpot. We map the enriched business profile data directly to your custom CRM fields.'
}];
export function EnrichmentFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-slate-50" data-id="element-4334">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4335">
        <div className="text-center mb-10" data-id="element-4336">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-4337">
            Frequently asked <span className="text-blue-600" data-id="element-4338">questions</span>
          </h2>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-4339">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-4340">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-4341">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-4342">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-4343" />
                </button>
                <AnimatePresence data-id="element-4344">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-4345">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-4346" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}